export const SCREENSHOT_TOOL_DATA_ATTR_MPT_ID = 'data-screenshot-tool';
export const SCREENSHOT_TOOL_DATA_HIDE = {
  'data-screenshot-tool-hide': 'true',
};
